import { SAVE_DYNAMIC_REPORT_ERROR, SAVE_DYNAMIC_REPORT_SUCCESS } from './actionTypes';

export const saveDynamicReportSuccess = payload => ({ type: SAVE_DYNAMIC_REPORT_SUCCESS, payload });
export const saveDynamicReportError = payload => ({ type: SAVE_DYNAMIC_REPORT_ERROR, payload });
